<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap" v-if="data.error">
                <div>
                  <span>{{data.text}} 취소에 실패했습니다</span>
                </div>
            </div>
            <div class="popup-wrap" v-if="!data.error">
              <div>
                <span>{{year}}년 {{month}}월 {{day}}일에 {{data.text}} 된</span>
                <span>{{data.price | comma}}원이 취소되었습니다</span>
              </div>
            </div>
          <div class="button-wrap">
            <button class="button-bg-gray" @click.prevent="$emit('charge-popup', [null, false])">닫기</button>
          </div>
        </div>
    </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: 'MyDetailChargeCancelConfirmPopup',
  props: ["data"],
  data() {
    return  {
      year: '',
      month: '',
      day: ''
    }
  },
  filters: {
    comma(num) {
      return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted() {
    this.dateFormat(this.data.firstDate);
  },
  methods : {
    dateFormat(date) {
      const yyyymmdd = dayjs(date);

      this.year = yyyymmdd.get("y");
      this.month = yyyymmdd.get("M") + 1;
      this.day = yyyymmdd.get("D");
    },
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/stopUsingPopup.scss';
</style>